/* KinderSpeech Halloween visszaszámláló (evergreen, cookie-alapú)
   - Első látogatáskor a cookie-ba kerül egy határidő (most + duration, alapból 3:39:00).
   - Lejáratkor 00:00:00-n megáll, majd restart-hours órával később újraindul.
   - A cookie legfeljebb 30 napig él (Safari kb. 7 napra rövidíti), minden oldalon
     ugyanazt a határidőt mutatja.
   - A hulló tökök csak a teljes betöltés után indulnak (kshw--live), hogy ne lassítsák az oldalt.
   - Idempotens: a témaszerkesztő section-újrarenderelése után is jól működik. */
(function () {
  var NAME = 'ks_hw_deadline';

  function most() {
    return Math.floor(Date.now() / 1000);
  }
  function getCookie() {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + NAME + '=(\\d+)'));
    return m ? parseInt(m[1], 10) : null;
  }
  function setCookie(val) {
    document.cookie = NAME + '=' + val + '; max-age=2592000; path=/; SameSite=Lax; Secure';
  }
  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function initTimer(el) {
    if (el.__kshwInterval) return;
    var outH = el.querySelector('[data-kshw-h]');
    var outM = el.querySelector('[data-kshw-m]');
    var outS = el.querySelector('[data-kshw-s]');
    if (!outH || !outM || !outS) return;

    var DURATION = parseInt(el.getAttribute('data-duration'), 10);
    if (!DURATION || DURATION < 60) DURATION = 13140; /* 3:39:00 */
    var RESTART_AFTER = parseInt(el.getAttribute('data-restart-hours'), 10);
    RESTART_AFTER = (RESTART_AFTER > 0 ? RESTART_AFTER : 6) * 3600;

    function ujHatarido() {
      var d = most() + DURATION;
      setCookie(d);
      return d;
    }

    var deadline = getCookie();
    /* nincs cookie, értelmetlen érték, vagy a mostani hossznál távolabbi határidő: újraindul */
    if (!deadline || deadline - most() > DURATION) {
      deadline = ujHatarido();
    } else {
      setCookie(deadline);
    }

    function tick() {
      if (!document.contains(el)) {
        clearInterval(el.__kshwInterval);
        el.__kshwInterval = null;
        return;
      }
      var now = most();
      /* más fülön újraindulhatott közben: mindig a cookie az igazság */
      var cd = getCookie();
      if (cd && cd !== deadline && cd - now <= DURATION) deadline = cd;

      var rem = deadline - now;
      if (rem <= 0) {
        if (now - deadline >= RESTART_AFTER) {
          deadline = ujHatarido();
          rem = deadline - now;
        } else {
          rem = 0;
        }
      }
      outH.textContent = pad(Math.floor(rem / 3600));
      outM.textContent = pad(Math.floor((rem % 3600) / 60));
      outS.textContent = pad(rem % 60);
    }

    tick();
    el.__kshwInterval = setInterval(tick, 1000);
  }

  /* Mobil betűméret: a legnagyobb méret, amivel a 2. és 3. sor még befér az óráig
     (az 1. sor két sorba törhet). 480 px felett a CSS fix méretei élnek. */
  var FS_MIN = 10, FS_MAX = 15, FS_FILL = 0.97;
  function fitText(bar) {
    var text = bar.querySelector('.kshw__text');
    if (!text) return;
    if (!window.matchMedia('(max-width: 479px)').matches) {
      bar.style.removeProperty('--kshw-fs');
      return;
    }
    var lines = text.querySelectorAll('.kshw__l1, .kshw__l2, .kshw__l3');
    bar.style.setProperty('--kshw-fs', FS_MIN + 'px');
    bar.classList.add('kshw--measure');
    var avail = text.clientWidth;
    var widest = 0, widestRest = 0;
    for (var i = 0; i < lines.length; i++) {
      var w = lines[i].scrollWidth;
      if (w > widest) widest = w;
      if (!lines[i].classList.contains('kshw__l1') && w > widestRest) widestRest = w;
    }
    bar.classList.remove('kshw--measure');
    function fsFor(px) {
      var v = px > 0 ? (avail * FS_FILL) / (px / FS_MIN) : FS_MIN;
      return Math.max(FS_MIN, Math.min(FS_MAX, Math.floor(v * 2) / 2));
    }
    /* alap: minden sor egy sorban; ha az 1. sor két sorba törésével legalább 15%-kal
       nagyobb betű jön ki (hosszabb első sornál), akkor az */
    var fs1 = fsFor(widest);
    var fs2 = fsFor(Math.max(widestRest, widest / 1.9));
    var fs = fs2 >= fs1 * 1.15 ? fs2 : fs1;
    bar.style.setProperty('--kshw-fs', fs + 'px');
  }
  function fitAll(root) {
    var bars = (root || document).querySelectorAll('[data-kshw-bar]');
    for (var i = 0; i < bars.length; i++) fitText(bars[i]);
  }
  var fitTimer = null;
  function fitSoon() {
    clearTimeout(fitTimer);
    fitTimer = setTimeout(function () { fitAll(document); }, 120);
  }
  window.addEventListener('resize', fitSoon);
  window.addEventListener('orientationchange', fitSoon);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { fitAll(document); });
  }

  function startConfetti(root) {
    var bars = (root || document).querySelectorAll('[data-kshw-bar]');
    var go = function () {
      for (var i = 0; i < bars.length; i++) bars[i].classList.add('kshw--live');
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(go, { timeout: 2500 });
    } else {
      setTimeout(go, 800);
    }
  }

  function initAll(root) {
    var list = (root || document).querySelectorAll('[data-kshw-timer]');
    for (var i = 0; i < list.length; i++) initTimer(list[i]);
    fitAll(root);
    if (document.readyState === 'complete') {
      startConfetti(root);
    } else {
      window.addEventListener('load', function () { startConfetti(root); }, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Shopify témaszerkesztő: újrarender után újrainit, eltávolításkor takarítás */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var list = e.target.querySelectorAll('[data-kshw-timer]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].__kshwInterval) clearInterval(list[i].__kshwInterval);
    }
  });
})();
